<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基础信息</div>
      </div>
      <div>
        <span>客户编码：</span>
        <span>{{ parseStrEmpty(formData.bizNo) }}</span>
      </div>
    </div>
    <el-form :model="formData" ref="form">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            客户名称：
            <span>{{ parseStrEmpty(formData.name) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            客户简称：
            <span>{{ parseStrEmpty(formData.customerAbbrev) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            联系人：
            <span>{{ parseStrEmpty(formData.ownerName) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            联系方式：
            <span>{{ parseStrEmpty(formData.ownerContact) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="24">
          <span class="line">
            收货地址：
            <span>{{ parseStrEmpty(formData.address) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            发票抬头：
            <span>{{ parseStrEmpty(formData.businessInformationName) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            纳税人识别号：
            <span>{{ parseStrEmpty(formData.taxpayerRegNo) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            注册地址：
            <span>{{ parseStrEmpty(formData.registeAddress) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            电话：
            <span>{{ parseStrEmpty(formData.phone) }}</span>
          </span>
        </el-col>
        <el-col :span="24" :xs="24">
          <span class="line">
            备注：
            <span>{{ parseStrEmpty(formData.remark) }}</span>
          </span>
        </el-col>
      </el-row>
    </el-form>
    <div class="title title-mt">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">
          收款账户
        </div>
      </div>
    </div>

    <div class="topmargin">
      <TablePublic 
        :colLists="colLists" 
        :tableData="formData.bankList" 
        :paginationFlag="false"
      >
      </TablePublic>
    </div>
    <Box :row="formData"></Box>
  </div>
</template>

<script>
import { getProcessFactory } from '@/api/manage/process-factory'
import TablePublic from '@/components/tablePublic'
import Box from '@/components/nameBox.vue'
export default {
  components: {
    TablePublic,
    Box
  },
  data() {
    return {
      colLists: [
        {
          prop: 'bankName',
          label: '开户行',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'bankAccount',
          label: '银行账号',
          isTrue: true,
          align: 'left',
        },
      ],
      tableData: [],
      formData: {},
    }
  },
  methods: {
    getDetails(row){
      if(row){
        getProcessFactory({ id: row.id })
          .then((res) => {
            if (res.flag) {
              let row = res.data
              this.formData = {
                ...row,
                address: (row.cnProvinceName === row.cnCityName ? row.cnProvinceName + row.cnDistrictName : row.cnProvinceName + row.cnCityName + row.cnDistrictName) + (row.locDetails || ""),
                bankList: row.bankList.map(d=>{
                  d.bankAccount = d.bankAccount.replace(/(\d{4})(?=\d)/g, "$1 ")
                  return d
                })
              }
            } else {
              this.$message.error(res.message)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    reset() {
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-form-item {
  margin-bottom: 0px;
}
.err {
  color: red;
  margin-left: 10px;
  font-size: 14px;
}
.topmargin {
  margin-top: 20px;
}
.line {
  line-height: 35px;
}
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-top: 10px;
  }
}
</style>